import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PartnersList } from './components/PartnersList';
import { PartnerForm } from './components/PartnerForm';
import SinglePartner from './single';

const PartnersRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<PartnersList />} />
      <Route path='create' element={<PartnerForm />} />
      <Route path='edit/:id' element={<PartnerForm />} />
      <Route path=':id' element={<SinglePartner />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default PartnersRoutes;


